<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-position="top"
                 label-width="100px">
            <el-form-item label="请填写退回意见" prop="opinion">
                <el-input v-model.trim="searchForm.opinion" maxlength="100"
                          type="textarea" rows="5" resize="none"
                          placeholder="请输入退回意见(限100字)"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "retreatMark",
    data() {
        return {
            title: '标注退回',
            visible: false,
            searchForm: {
                opinion: '',
            },
            rules: {
                opinion: [
                    {required: true, message: '请填写退回意见', trigger: 'blur'}
                ],
            },
            selectData: {},
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.selectData = row
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
        },

        //退回
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                    if (valid) {
                        this.$axios(this.api.academic.resourceslabelSendBack, {
                            id: this.selectData.id,
                            labeState: 4,
                            ...this.searchForm,
                        }, 'put').then(data => {
                                if (data && data.status) {
                                    this.$message.success('退回成功')
                                    this.visible = false
                                    this.$emit('refresh')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            }
                        )
                    }
                }
            )
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>
